import React, {useContext} from "react";
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import {
  UserContext
} from "m34n-ui";

const navLinks = [
  { label: 'Scheduler', path: '/admin' },
  { label: 'Book', path: '/book' },
  { label: 'Landing', path: '/'}
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const handleLogout = () => {
    logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <AppBar
        position="sticky"
        color="transparent"
        elevation={0}
        sx={{ borderBottom: '1px solid rgba(244,243,248,0.12)' }}
      >
        <Toolbar sx={{ gap: 2 }}>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Pluto TV • Rage Room Admin
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ display: { xs: 'none', md: 'flex' } }}>
            {navLinks.map((item) => (
              <Button
                key={item.path}
                component={NavLink}
                to={item.path}
                end={item.path === '/admin'}
                color="inherit"
                sx={{
                  fontWeight: 600,
                  '&.active': { color: 'primary.main' },
                }}
              >
                {item.label}
              </Button>
            ))}
            <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(244,243,248,0.12)' }} />
            {user?.email && (
              <Chip
                label={user.email}
                size="small"
                sx={{
                  backgroundColor: 'rgba(60,31,255,0.18)',
                  border: '1px solid rgba(244,243,248,0.16)',
                }}
              />
            )}
            <Button variant="outlined" color="secondary" onClick={handleLogout}>
              Logout
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <Stack
        spacing={1}
        sx={{
          display: { xs: 'flex', md: 'none' },
          px: 2,
          py: 2,
          borderBottom: '1px solid rgba(244,243,248,0.12)',
          backgroundColor: 'background.paper',
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
          {navLinks.map((item) => (
            <Button
              key={item.path}
              component={NavLink}
              to={item.path}
              end={item.path === '/admin'}
              variant="outlined"
              size="small"
            >
              {item.label}
            </Button>
          ))}
        </Stack>
        <Button variant="contained" color="secondary" size="small" onClick={handleLogout}>
          Logout
        </Button>
      </Stack>

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        <Outlet />
      </Container>
    </Box>
  );
};

export default AdminLayout;